import MultipleOptions from './MultipleOptions';

export default MultipleOptions;


// WEBPACK FOOTER //
// /src/components/mailThread/compose/messageHandler/multipleOptions/index.js